// extracted by mini-css-extract-plugin
export default {"tabs":"ButtonsHeader_tabs__PerFI","item":"ButtonsHeader_item__UYxX6"};